import _BUSINESS_VALIDATION_STATUSES from '~/server_shared/generated-types/BUSINESS_VALIDATION_STATUSES';
import CONTACT_VALIDATION_TYPES from '~/server_shared/generated-types/CONTACT_VALIDATION_TYPES';
import type { GbgBusinessRetrieveResponseGbgBusinessRetrieveValidation } from '~/server_shared/openapi/data-contracts';

export type BusinessValidationStatus = NonNullable<GbgBusinessRetrieveResponseGbgBusinessRetrieveValidation['status']>;

export const BUSINESS_VALIDATION_STATUSES = _BUSINESS_VALIDATION_STATUSES satisfies Record<
  string,
  BusinessValidationStatus
>;

export const REVERTABLE_BUSINESS_STATUSES: BusinessValidationStatus[] = [
  BUSINESS_VALIDATION_STATUSES.BN_VERIFIED,
  BUSINESS_VALIDATION_STATUSES.BN_VERIFIED_NO_GST,
  BUSINESS_VALIDATION_STATUSES.BN_VERIFIED_GST_UNKNOWN,
  BUSINESS_VALIDATION_STATUSES.BN_CANCELLED,
  BUSINESS_VALIDATION_STATUSES.BN_INVALID,
];

export const BUSINESS_VALIDATION_TYPE = CONTACT_VALIDATION_TYPES.BUSINESS;
